import { Box, Grid, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import DropMedia from "../../../components/DropMedia";
import AddIcon from "@mui/icons-material/Add";
import { allIcons } from "../../../assets";
import axios from "axios";

const UpdateVenueImages = ({ inputValues, setInputValues }) => {
  const [previewImage, setPreviewImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const uploadRef = useRef();

  const uploadToCloudinary = async (file) => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "tuytnefv");
    formData.append("cloud_name", "dgooan4ix");

    try {
      const res = await axios.post(
        "https://api.cloudinary.com/v1_1/dgooan4ix/upload",
        formData
      );
      setIsLoading(false);
      return res.data.secure_url;
    } catch (error) {
      setIsLoading(false);
      console.error("Image upload failed:", error);
      return null;
    }
  };

  const handleImage = async (files) => {
    if (!files.length) return;
    const uploadedUrl = await uploadToCloudinary(files[0]);

    if (uploadedUrl) {
      setInputValues({
        ...inputValues,
        venueCoverImage: uploadedUrl,
      });
    }
  };

  const handleAddImages = async (event) => {
    if (event.target.files.length === 0) return;

    const file = event.target.files[0];
    const uploadedUrl = await uploadToCloudinary(file);

    if (uploadedUrl) {
      setInputValues((prev) => ({
        ...prev,
        venueImages: [...prev.venueImages, uploadedUrl],
      }));
    }
  };

  return (
    <Grid
      spacing={4}
      container
      sx={{ alignItems: "center", justifyContent: "center" }}
    >
      <Grid item xs={12} sm={6}>
        <Typography
          variant="h3"
          sx={{ fontWeight: "700", fontSize: "35px", margin: "12px 0" }}
        >
          Update venue images
        </Typography>
        <Typography
          variant="h3"
          sx={{
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "22px",
            marginBottom: "15px",
          }}
        >
          Add at least 3 images of your location to your profile. You can add
          more or make changes later. Drag and drop to change the order of the
          images.
        </Typography>

        <DropMedia handleChangeImage={handleImage} />

        {isLoading && <Typography>Uploading...</Typography>}

        {inputValues?.venueCoverImage && (
          <Box sx={{ margin: "20px 0", position: "relative" }}>
            <Box
              sx={{
                position: "absolute",
                bottom: 10,
                left: 10,
                background: "#fff",
                padding: "3px 10px",
                borderRadius: "20px",
              }}
            >
              <Typography
                sx={{ color: "#7c86a9", fontSize: "14px", fontWeight: "600" }}
              >
                Cover image
              </Typography>
            </Box>
            <img
              src={inputValues?.venueCoverImage}
              style={{ width: "100%", height: "400px" }}
            />
          </Box>
        )}

        <Grid container spacing={3} marginTop={"10px"} marginBottom={"30px"}>
          {inputValues.venueImages.map((imageUrl, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Box
                sx={{
                  background: "#f2f2f2",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "200px",
                  borderRadius: "10px",
                  border: "2px solid #f2f2f2",
                  position: "relative",
                }}
              >
                <img src={imageUrl} style={{ width: "100%", height: "100%" }} />
                <Box
                  sx={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    background: "#fff",
                    padding: "3px 10px",
                    borderRadius: "20px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    const updatedImages = inputValues.venueImages.filter(
                      (_, i) => i !== index
                    );
                    setInputValues({
                      ...inputValues,
                      venueImages: updatedImages,
                    });
                  }}
                >
                  <img
                    src={allIcons.deleteIcon}
                    style={{ width: "20px", height: "20px" }}
                  />
                </Box>
              </Box>
            </Grid>
          ))}
          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                background: "#f2f2f2",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "200px",
                borderRadius: "10px",
                cursor: "pointer",
              }}
              onClick={() => uploadRef.current.click()}
            >
              <AddIcon />
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <input
        style={{
          height: 0,
          width: 0,
          margin: 0,
          padding: 0,
          visibility: "hidden",
        }}
        ref={uploadRef}
        accept="image/jpeg, image/png"
        type="file"
        onChange={handleAddImages}
      />
    </Grid>
  );
};

export default UpdateVenueImages;
